import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { marketsUrl } from '@/urls'
import { getLocalePrefix } from '@/util/localePath'

/**
 * Legacy entry point. Results live on the markets feed under `?search=`; `q` is
 * the parameter the old JSON-LD SearchAction advertised.
 */
const SearchRedirect = () => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const term = params.get('search') || params.get('q') || ''
  const query = term ? `?${new URLSearchParams({ search: term }).toString()}` : ''

  return <Navigate to={`${getLocalePrefix(location.pathname)}${marketsUrl()}${query}`} replace />
}

export default SearchRedirect
